import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "truncate"
}

import { computed } from 'vue'
import { CARRIERS } from '@/types/carrier'
import type { CarrierType } from '@/types/carrier'

interface Props {
  carrier: CarrierType
  showName?: boolean
  compact?: boolean
  label?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CarrierBadge',
  props: {
    carrier: {},
    showName: { type: Boolean, default: true },
    compact: { type: Boolean, default: false },
    label: {}
  },
  setup(__props: any) {

const props = __props

const displayName = computed(
  () => props.label?.trim() || CARRIERS[props.carrier].name,
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'inline-flex items-center rounded-full font-medium max-w-full',
      _ctx.compact ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-1 text-xs',
      _unref(CARRIERS)[_ctx.carrier].bgColor,
      _unref(CARRIERS)[_ctx.carrier].color,
    ]),
    title: displayName.value
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(_unref(CARRIERS)[_ctx.carrier].icon + (_ctx.showName ? ' mr-1 shrink-0' : ''))
    }, null, 2),
    (_ctx.showName)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(displayName.value), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})